import { render, staticRenderFns } from "./search.page.pug?vue&type=template&id=4e064270&scoped=true&lang=pug&external"
import script from "./search.page.ts?vue&type=script&lang=js&external"
export * from "./search.page.ts?vue&type=script&lang=js&external"
import style0 from "./search.page.sass?vue&type=style&index=0&id=4e064270&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e064270",
  null
  
)

export default component.exports